<script>

    import { createEventDispatcher } from 'svelte';
    import { slide, fade } from 'svelte/transition';
    import { notificationTypes, TOAST_DEFAULT_CLOSE_TIMEOUT } from '@repo/config/Global';
    /**
     * @typedef {Object} Props
     * @property {any} type
     * @property {any} message
     * @property {boolean} [autoClose]
     * @property {any} click
     * @property {number} [closeTime]
     * @property {any} id
     */
    let {
        type,
        message,
        autoClose = true,
        click,
        closeTime = TOAST_DEFAULT_CLOSE_TIMEOUT,
        id
    } = $props();

    const dispatch = createEventDispatcher();

    let item = $state();
    
    function handleCloseClick() { 
        dispatch('remove', id); 
    }
    
    function handleItemClick() {
        if (click) click();
        handleCloseClick();
    }

    function init(el) {
        setTimeout(handleCloseClick, closeTime);
    }

</script>


<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<li use:init bind:this={item} onclick={handleItemClick} in:slide out:fade class="toast-item interactive {type}" data-id={id} role="alert">
    {#if type === notificationTypes.ERROR}
        <i class="material-icons" aria-hidden="true">error</i>
    {/if}
    {#if type === notificationTypes.WARN}
        <i class="material-icons" aria-hidden="true">warning</i>
    {/if}
    {#if type === notificationTypes.NEUTRAL}
        <i class="material-icons" aria-hidden="true">notifications</i>
    {/if}
    {#if type === notificationTypes.SUCCESS}
        <i class="material-icons" aria-hidden="true">check_circle</i>
    {/if}
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    <span>{@html message}</span>
    <div class="spacer"></div>
    <button onclick={handleCloseClick}>
        <i onclick={handleCloseClick} class="material-icons">close</i>
    </button>
</li>


<style>
    .toast-item{
        display:flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        max-width:18rem;
        padding:0.75rem 0.75rem 0.75rem 0.75rem;
        margin-bottom:0.25rem;
        border-radius:0.5rem;
        box-shadow:0 0.25rem 0.5rem rgba(0,0,0,0.2);
    }

    .toast-item span{
        margin-top:0.25rem;
        font-size:0.8rem;
    }

    .toast-item i:first-of-type{
        margin-right:0.5rem;
    }

    .toast-item i:last-of-type{
        margin-left:0.5rem;
    }

    .notification_error {
        background-color:crimson;
        color:white;
    }

    .notification_warn {
        background-color:rgb(255, 192, 74);
        color:#333;
    }

    .notification_neutral{
        background-color:rgb(199, 199, 199);
        color:#333;
    }
    .notification_success {
        background-color:rgb(74, 255, 83);
        color:#333;
    }

    button {
        background: transparent;
    }
    
    .notification_error button {
        color:white;
    }

    .notification_warn button,
    .notification_success button,
    .notification_neutral button {
        color:#333;
    } 
</style>
